import React from "react";
import { BiChevronDown } from "react-icons/bi";
import { toScoreValue } from "../../utils/scoreState";

const TeamScoresSubheadingRow = ({
  subheading,
  subIndex,
  scale,
  openCommentDropdownId,
  setOpenCommentDropdownId,
  normalizeScoreValue,
  getScorePillStyle,
  getSubheadingComments,
}) => {
  // Display values are blank for anything off the heading's scale, so presence
  // is decided on the raw numbers rather than on what is rendered.
  const medianValue = normalizeScoreValue(subheading?.median, scale);
  const teamScoreValue = normalizeScoreValue(subheading?.teamScore, scale);
  const medianNumber = toScoreValue(subheading?.median, scale);
  const teamScoreNumber = toScoreValue(subheading?.teamScore, scale);
  const hasTeamScore = teamScoreNumber !== null;
  // Only surface the team score when it differs from the median; when they
  // match, the median already represents the value so the cell stays empty.
  const showTeamScore = hasTeamScore && teamScoreNumber !== medianNumber;
  const medianPill = showTeamScore
    ? { className: "bg_grey", style: undefined }
    : getScorePillStyle(medianValue, scale, "bg_light");
  const teamScorePill = getScorePillStyle(teamScoreValue, scale, "head_light");
  const comments = getSubheadingComments(subheading);
  const commentDropdownId = subheading.id || `comment-${subIndex}`;

  return (
    <div className="d-flex align-items-center bg_light my-1 h-35 mx-0">
      <div
        className="d-flex align-items-center justify-content-center flex-grow-1"
        style={{
          width: 280,
          textAlign: "center",
        }}
      >
        <small
          className="small-text"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "260px",
          }}
        >
          {subheading.subheadingName}
        </small>
      </div>
      <div
        className="d-flex align-items-center justify-content-center flex-grow-1"
        style={{ minWidth: 200 }}
      >
        <div className="dropdown">
          <button
            className="btn py-1 border text-left bg-white fs-13"
            type="button"
            id={`commentDropdown-${commentDropdownId}`}
            aria-expanded={openCommentDropdownId === commentDropdownId}
            onClick={(event) => {
              event.stopPropagation();
              setOpenCommentDropdownId((prev) =>
                prev === commentDropdownId ? null : commentDropdownId
              );
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <small>
                {comments.length
                  ? `Comments (${comments.length})`
                  : "No comments"}
              </small>
              <BiChevronDown size={24} className="navbar-btn-icon" />
            </div>
          </button>
          <div
            className={`dropdown-menu dropdown-menu--animate custom border-0 shadow fs-13 ${
              openCommentDropdownId === commentDropdownId ? "show" : ""
            }`}
            aria-labelledby={`commentDropdown-${commentDropdownId}`}
            style={{
              minWidth: "320px",
              zIndex: 1060,
              backgroundColor: "#fff",
            }}
            onClick={(event) => event.stopPropagation()}
          >
            <p className="pl-4 mb-0 pb-2">
              <small>
                {comments.length ? "Contributors:" : "No comments available"}
              </small>
            </p>
            {comments.map((commentItem) => (
              <div
                className="dropdown-item ml-4"
                key={commentItem.id}
                style={{ whiteSpace: "normal" }}
              >
                <small>
                  <span className="font-weight-bold">{commentItem.name}:</span>{" "}
                  {commentItem.comment}
                </small>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ width: 90 }}
      >
        <div
          className={`w-35 h-27 rounded-pill d-flex align-items-center justify-content-center ${medianPill.className}`}
          style={medianPill.style}
        >
          <span className="fs-14 font-weight-bold">{medianValue}</span>
        </div>
      </div>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ width: 90 }}
      >
        {showTeamScore ? (
          <div
            className={`w-35 h-27 rounded-pill d-flex align-items-center justify-content-center ${teamScorePill.className}`}
            style={teamScorePill.style}
          >
            <span className="fs-14 font-weight-bold">{teamScoreValue}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default TeamScoresSubheadingRow;
